import Vue from './../vue';
import Vuex from 'vuex';

import WorkspaceModule from './modules/workspaces';
import PropertiesModule from './modules/properties';
import AppModule from './modules/app';
import OnboardingModule from './modules/onboarding';
import LandingPageModule from './modules/landing-page';

import {AuthPersistence, AuthStoreModule} from '@milestoneslabs/milestones-unified-login';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth: AuthStoreModule,
        workspace: WorkspaceModule,
        properties: PropertiesModule,
        app: AppModule,
        onboarding: OnboardingModule,
        landingPage: LandingPageModule,
    },
    plugins: [
        AuthPersistence.createInstance(['auth', 'onboarding']).plugin,
    ],
});
